import styled, { css } from 'styled-components';

const Root = styled.header.attrs({
    $sizes: {
        small: css `
      padding: 8px 24px;
    `,
        medium: css `
      padding: 8px 24px;
    `,
        large: css `
      padding: 8px 24px;
    `,
    },
}) `
  position: ${props => (props.$sticky ? 'sticky' : 'static')};
  z-index: 999;

  top: 0;
  display: flex;
  align-items: center;
  gap: 24px;

  background-color: ${props => props.theme.colors.gray0};
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${props => props.theme.colors.gray100};

  ${props => props.$sizes[props.$size]};
`;

export { Root };
//# sourceMappingURL=styled.js.map
